import api from 'api'
import { fetchWithToken } from 'utils'
import { GtcBillingAccess } from '../types/GtcBillingAccess'

const fetchGtcBillingAccess = async ({ organizationId }): Promise<GtcBillingAccess | undefined> => {
  try {
    const response = await fetchWithToken({
      method: 'GET',
      resource: api.billingPortalBff,
      useExternalAdmin: false,
      path: `v1/organizations/${organizationId}/access`,
      useVersion: '',
      useV5: false,
    })

    if (response.ok) {
      return response.json()
    }
    console.error('Response returned with not OK status', response)
  } catch (err: any) {
    console.error(err.toString())
  }
}

export default fetchGtcBillingAccess
